import { InjectionToken } from '@angular/core';
import { captureException } from '@sentry/angular';

// Inject Sentry rather than importing it directly so specs can provide a mock. Mocking the
// '@sentry/angular' module instead is unreliable: specs share one module registry, so a consumer
// imported by an earlier spec keeps the real module.
export const SENTRY_TOKEN = new InjectionToken<{
  captureException: typeof captureException;
}>('SentryAngular', {
  providedIn: 'root',
  factory: () => ({ captureException }),
});
